import { api } from 'API';
import { addImposterToUrl } from 'Utils';
const baseUrl = '/Notifications';

export interface IUserUpdates {
  id: number;
  caseNumber: string;
  createDate: Date;
  shemeshCreateDate: Date;
  title: string;
  description: string;
  notifEntityId: number;
  notifSubjectId: number;
  entityJSON: string;
  readedDate: Date | null;
  filterLabel: string;
}

export interface GeneralItem {
  id: string;
}

export interface MedicalReferralItem extends GeneralItem {
  Subject: string;
  HasFile: boolean;
  Id: string;
}

export interface DocumentItem extends GeneralItem {
  name: string;
}

export interface EntityJSON<T extends GeneralItem> {
  title: string;
  items: T[];
}

export interface UpdateNotifToReadedResponse {
  notifId: number;
  readedDate: Date;
}

export enum NotifSubjectsType {
  MedicalReferrals = 1,
  Documents = 2,
  PaymentsAndDeductions = 3,
  Applies = 4,
  RecognitionStatus = 5,
  Prescriptions = 6,
  Medications = 7,
  ConsumEquipOrders = 8,
}

export enum NotificationSubject {
  MedicalRefs_Group = 1,
  MedicalRefs_Single = 2,
  Documents_Single = 3,
  PaymentsAndDeductions_Groupe = 4,
  PaymentsAndDeductions_Single = 5,
  Applies_ForwardedToExpertStatus = 6,
  Applies_ExpertReplyWasReceivedStatus = 7,
  RecogStatus_RequestExam_Single = 8,
  RecogStatus_RequestExam_Group = 9,
  RecogStatus_MedicalOpinion_Single = 10,
  RecogStatus_MedicalOpinion_Group = 11,
  RecogStatus_WaitForDecistion_Single = 12,
  RecogStatus_WaitForDecistion_Group = 13,
  RecogStatus_MedicalCommite_Single = 14,
  RecogStatus_MedicalCommite_Group = 15,
  RecogStatus_DisableDetermination_Single = 16,
  RecogStatus_DisableDetermination_Group = 17,
  RecogStatus_Pause_Single = 18,
  RecogStatus_Pause_Group = 19,
  RecogStatus_Rejection_Single = 20,
  RecogStatus_Rejection_Group = 21,
  RecogStatus_Ended_Single = 24,
  RecogStatus_Ended_Group = 25,
  PrescriptionStatus_ManualPrescApproved = 26,
  PrescriptionStatus_WingHandling = 27,
  PrescriptionStatus_SuperPharmHandling = 28,
  PrescriptionStatus_AwaitForDeliveryAtSuperpharm = 29,
  PrescriptionStatus_SuperpharmFullySupply = 30,
  PrescriptionStatus_SuperpharmPartialSupply = 31,
  PrescriptionStatus_Rejected = 32,
  Medications_NewMedApproved_Single = 33,
  Medications_NewMedApproved_Group = 34,
  ConsumEquipStatus_WingHandling = 35,
  ConsumEquipStatus_SuperPharmHandling = 36,
  ConsumEquipStatus_SuperpharmFullySupply = 37,
  ConsumEquipStatus_SuperpharmPartialSupply = 38,
}

export const getUpdates = async () => {
  const res = await api.get<IUserUpdates[]>(addImposterToUrl(baseUrl, true));
  if (res) return { status: res.status, data: res?.data };
};

export const setNotifReaded = async (id: number) => {
  const res = await api.patch<UpdateNotifToReadedResponse[]>(
    addImposterToUrl(`${baseUrl}/readed/${id}`, true)
  );
  if (res) return res;
};
